<template>
	<v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
		<v-app-bar-nav-icon @click.stop="menuShowToggle()" />
		<v-toolbar-title style="width: 300px" class="ml-0 pl-4">
			<span class="hidden-sm-and-down">Arba CRM</span>
		</v-toolbar-title>
		<!-- <v-text-field flat solo-inverted hide-details prepend-inner-icon="fa fa-search" label="Search" class="hidden-sm-and-down" /> -->
		<v-spacer />
		<!-- <v-btn icon>
			<v-icon>mdi-apps</v-icon>
		</v-btn>
		<v-btn icon>
			<v-icon>mdi-bell</v-icon>
		</v-btn> -->
		<v-btn icon large >
			<v-avatar size="32px" item v-if="getAuth.isSigned" color="#fff" padding="4">
				<v-img :src="getAuth.client.logo" alt="Vuetify" />
			</v-avatar>
		</v-btn>
	</v-app-bar>
</template>

<script>  
    export default {
		components:{ 
		},
        props: {
            source: String,
        },
        data: () => ({
            dialog: false,
            drawer: null,
		}),
		methods:{
			menuShowToggle(){
				this.$store.dispatch("a_menuShowToggle")
			}
		},
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    }
</script>